import { render } from "./App.vue?vue&type=template&id=cd65095a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cd65095a&lang=css"

import exportComponent from "C:\\Fit20\\Fit20Start Project\\fit20start\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__